var NAUDIO = (function () {
  // ------------------------------------------------------------ bit writer
  function BW(cap) { this.buf = new Uint8Array(cap || 65536); this.pos = 0; this.acc = 0; this.n = 0; }
  BW.prototype.grow = function (need) {
    if (this.pos + need <= this.buf.length) return;
    var nb = new Uint8Array(Math.max(this.buf.length * 2, this.pos + need + 1024)); nb.set(this.buf.subarray(0, this.pos)); this.buf = nb;
  };
  BW.prototype.bits = function (v, n) { // n <= 24 per call
    if (n > 24) { this.bits(Math.floor(v / 16777216) & ((1 << (n - 24)) - 1), n - 24); v = v % 16777216; n = 24; }
    this.acc = (this.acc * (1 << n)) + (v & ((1 << n) - 1)) >>> 0; this.n += n;
    // keep acc below 2^32 by flushing whole bytes
    this.grow(8);
    while (this.n >= 8) { this.n -= 8; this.buf[this.pos++] = (this.acc >>> this.n) & 255; }
    this.acc &= (1 << this.n) - 1;
  };
  BW.prototype.unary = function (q) { // q zeros then a one
    while (q >= 24) { this.bits(0, 24); q -= 24; }
    this.bits(1, q + 1);
  };
  BW.prototype.align = function () { if (this.n) this.bits(0, 8 - this.n); };
  BW.prototype.bytes = function () { return this.buf.subarray(0, this.pos); };

  var CRC8 = new Uint8Array(256), CRC16 = new Uint16Array(256);
  (function () {
    for (var i = 0; i < 256; i++) {
      var c = i; for (var j = 0; j < 8; j++) c = (c & 128) ? ((c << 1) ^ 7) & 255 : (c << 1) & 255; CRC8[i] = c;
      var d = i << 8; for (j = 0; j < 8; j++) d = (d & 32768) ? ((d << 1) ^ 0x8005) & 65535 : (d << 1) & 65535; CRC16[i] = d;
    }
  })();
  function crc8(b, s, e) { var c = 0; for (var i = s; i < e; i++) c = CRC8[c ^ b[i]]; return c; }
  function crc16(b, s, e) { var c = 0; for (var i = s; i < e; i++) c = ((c << 8) ^ CRC16[(c >> 8) ^ b[i]]) & 65535; return c; }

  // ------------------------------------------------------------ helpers
  function toInt(ch, bps, gain) { // Float32Array[] -> Int32Array[]
    var max = bps === 24 ? 8388607 : 32767, out = [];
    for (var c = 0; c < ch.length; c++) {
      var src = ch[c], d = new Int32Array(src.length);
      for (var i = 0; i < src.length; i++) { var x = src[i] * (gain || 1); x = x > 1 ? 1 : x < -1 ? -1 : x; d[i] = Math.round(x * max); }
      out.push(d);
    }
    return out;
  }
  function concat(parts) {
    var n = 0, i; for (i = 0; i < parts.length; i++) n += parts[i].length;
    var o = new Uint8Array(n), p = 0; for (i = 0; i < parts.length; i++) { o.set(parts[i], p); p += parts[i].length; } return o;
  }
  function utf8(s) { return new TextEncoder().encode(s); }

  // ------------------------------------------------------------ WAV
  function wav(chs, sr, bps) {
    var ints = toInt(chs, bps), nc = ints.length, n = ints[0].length, bpsB = bps / 8;
    var ab = new ArrayBuffer(44 + n * nc * bpsB), v = new DataView(ab), u = new Uint8Array(ab), o = 44;
    function s(off, str) { for (var k = 0; k < str.length; k++) v.setUint8(off + k, str.charCodeAt(k)); }
    s(0, 'RIFF'); v.setUint32(4, 36 + n * nc * bpsB, true); s(8, 'WAVE'); s(12, 'fmt '); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, nc, true);
    v.setUint32(24, sr, true); v.setUint32(28, sr * nc * bpsB, true); v.setUint16(32, nc * bpsB, true); v.setUint16(34, bps, true); s(36, 'data'); v.setUint32(40, n * nc * bpsB, true);
    for (var i = 0; i < n; i++) for (var c = 0; c < nc; c++) {
      var x = ints[c][i];
      if (bps === 16) { v.setInt16(o, x, true); o += 2; }
      else { u[o] = x & 255; u[o + 1] = (x >> 8) & 255; u[o + 2] = (x >> 16) & 255; o += 3; }
    }
    return u;
  }

  // ------------------------------------------------------------ FLAC
  function riceBits(res, s, e, k) { var b = 0; for (var i = s; i < e; i++) { var u = res[i] >= 0 ? res[i] * 2 : -res[i] * 2 - 1; b += (u >>> k) + 1 + k; } return b; }
  function bestK(res, s, e) {
    var sum = 0; for (var i = s; i < e; i++) sum += res[i] >= 0 ? res[i] * 2 : -res[i] * 2 - 1;
    var mean = (e - s) ? sum / (e - s) : 0, k = mean > 1 ? Math.floor(Math.log2(mean)) : 0;
    var best = -1, bk = 0;
    for (var t = Math.max(0, k - 1); t <= Math.min(30, k + 1); t++) { var b = riceBits(res, s, e, t); if (best < 0 || b < best) { best = b; bk = t; } }
    return { k: bk, bits: best };
  }
  function fixedResidual(x, order, out) {
    var n = x.length, i;
    for (i = order; i < n; i++) {
      switch (order) {
        case 0: out[i] = x[i]; break;
        case 1: out[i] = x[i] - x[i - 1]; break;
        case 2: out[i] = x[i] - 2 * x[i - 1] + x[i - 2]; break;
        case 3: out[i] = x[i] - 3 * x[i - 1] + 3 * x[i - 2] - x[i - 3]; break;
        default: out[i] = x[i] - 4 * x[i - 1] + 6 * x[i - 2] - 4 * x[i - 3] + x[i - 4];
      }
    }
  }
  // plan the cheapest fixed subframe; returns {bits, write(bw)}
  function planSub(x, bps) {
    var n = x.length, best = null, res = new Int32Array(n);
    var allSame = true; for (var i = 1; i < n; i++) if (x[i] !== x[0]) { allSame = false; break; }
    if (allSame) return { bits: 8 + bps, write: function (bw) { bw.bits(0, 8); bw.bits(x[0] < 0 ? x[0] + Math.pow(2, bps) : x[0], bps); } };
    for (var order = 0; order <= Math.min(4, n - 1); order++) {
      fixedResidual(x, order, res);
      for (var p = 0; p <= 4; p++) {
        if (n % (1 << p) || (n >> p) <= order) break;
        var ps = n >> p, bits = 8 + order * bps + 6, ks = [];
        for (var q = 0; q < (1 << p); q++) {
          var s0 = q === 0 ? order : q * ps, e0 = (q + 1) * ps, r = bestK(res, s0, e0);
          bits += 5 + r.bits; ks.push(r.k);
        }
        if (!best || bits < best.bits) best = { bits: bits, order: order, p: p, ks: ks, res: res.slice() };
      }
    }
    var verb = 8 + n * bps;
    if (verb <= best.bits) return { bits: verb, write: function (bw) { bw.bits(2, 8); for (var i = 0; i < n; i++) bw.bits(x[i] < 0 ? x[i] + Math.pow(2, bps) : x[i], bps); } };
    var B = best;
    return {
      bits: B.bits, write: function (bw) {
        bw.bits(0x10 | (B.order << 1), 8); // 0 + 001xxx + 0
        for (var i = 0; i < B.order; i++) bw.bits(x[i] < 0 ? x[i] + Math.pow(2, bps) : x[i], bps);
        bw.bits(1, 2); bw.bits(B.p, 4);
        var ps = n >> B.p;
        for (var q = 0; q < (1 << B.p); q++) {
          var k = B.ks[q], s0 = q === 0 ? B.order : q * ps, e0 = (q + 1) * ps; bw.bits(k, 5);
          for (var j = s0; j < e0; j++) { var u = B.res[j] >= 0 ? B.res[j] * 2 : -B.res[j] * 2 - 1; bw.unary(u >>> k); if (k) bw.bits(k > 24 ? u % Math.pow(2, k) : u & ((1 << k) - 1), k); }
        }
      }
    };
  }
  function utf8num(bw, v) {
    if (v < 0x80) { bw.bits(v, 8); return; }
    var bytes = v < 0x800 ? 2 : v < 0x10000 ? 3 : v < 0x200000 ? 4 : 5;
    var lead = [0, 0, 0xC0, 0xE0, 0xF0, 0xF8][bytes], shift = (bytes - 1) * 6;
    bw.bits(lead | (v >>> shift), 8);
    for (var b = bytes - 2; b >= 0; b--) bw.bits(0x80 | ((v >>> (b * 6)) & 63), 8);
  }
  function flac(chs, sr, bps, meta, progress) {
    var ints = toInt(chs, bps), nc = ints.length, total = ints[0].length, BS = 4096;
    var srCode = { 44100: 9, 48000: 10, 96000: 11, 88200: 0, 32000: 8, 22050: 6, 24000: 7 }[sr]; if (srCode === undefined) srCode = 0;
    var parts = [utf8('fLaC')];
    // STREAMINFO
    var si = new BW(64); si.bits(BS, 16); si.bits(BS, 16); si.bits(0, 24); si.bits(0, 24); si.bits(sr, 20); si.bits(nc - 1, 3); si.bits(bps - 1, 5);
    si.bits(Math.floor(total / 4294967296), 4); si.bits(Math.floor(total / 65536) % 65536, 16); si.bits(total % 65536, 16); for (var z = 0; z < 16; z++) si.bits(0, 8);
    var blocks = [{ type: 0, data: si.bytes().slice() }];
    if (meta && (meta.title || meta.artist)) {
      var vend = utf8('NameOnTheBeat'), cm = [];
      if (meta.title) cm.push(utf8('TITLE=' + meta.title)); if (meta.artist) cm.push(utf8('ARTIST=' + meta.artist));
      var len = 4 + vend.length + 4; cm.forEach(function (c) { len += 4 + c.length; });
      var vb = new Uint8Array(len), dv = new DataView(vb.buffer), o = 0;
      dv.setUint32(o, vend.length, true); o += 4; vb.set(vend, o); o += vend.length; dv.setUint32(o, cm.length, true); o += 4;
      cm.forEach(function (c) { dv.setUint32(o, c.length, true); o += 4; vb.set(c, o); o += c.length; });
      blocks.push({ type: 4, data: vb });
    }
    if (meta && meta.cover) {
      var mime = utf8(meta.coverMime || 'image/jpeg'), img = meta.cover, pb = new Uint8Array(32 + mime.length + img.length), pv = new DataView(pb.buffer), q = 0;
      pv.setUint32(q, 3); q += 4; pv.setUint32(q, mime.length); q += 4; pb.set(mime, q); q += mime.length; pv.setUint32(q, 0); q += 4;
      pv.setUint32(q, meta.coverW || 0); q += 4; pv.setUint32(q, meta.coverH || 0); q += 4; pv.setUint32(q, 24); q += 4; pv.setUint32(q, 0); q += 4;
      pv.setUint32(q, img.length); q += 4; pb.set(img, q);
      blocks.push({ type: 6, data: pb });
    }
    blocks.forEach(function (b, i) {
      var h = new Uint8Array(4); h[0] = (i === blocks.length - 1 ? 128 : 0) | b.type; h[1] = (b.data.length >> 16) & 255; h[2] = (b.data.length >> 8) & 255; h[3] = b.data.length & 255;
      parts.push(h, b.data);
    });
    var frame = 0;
    for (var start = 0; start < total; start += BS, frame++) {
      var n = Math.min(BS, total - start), bw = new BW(n * nc * 4 + 64);
      var subs, chanCode;
      var blk = ints.map(function (d) { return d.subarray(start, start + n); });
      if (nc === 2) {
        var side = new Int32Array(n); for (var i = 0; i < n; i++) side[i] = blk[0][i] - blk[1][i];
        var L = planSub(blk[0], bps), R = planSub(blk[1], bps), S = planSub(side, bps + 1);
        if (L.bits + S.bits < L.bits + R.bits) { subs = [L, S]; chanCode = 8; } else { subs = [L, R]; chanCode = 1; }
      } else { subs = [planSub(blk[0], bps)]; chanCode = 0; }
      bw.bits(0xFFF8, 16);
      bw.bits(n === BS ? 12 : 7, 4); bw.bits(srCode, 4); bw.bits(chanCode, 4); bw.bits(bps === 24 ? 6 : 4, 3); bw.bits(0, 1);
      utf8num(bw, frame);
      if (n !== BS) bw.bits(n - 1, 16);
      bw.align(); var hb = bw.bytes(); bw.bits(crc8(hb, 0, bw.pos), 8);
      subs.forEach(function (s) { s.write(bw); });
      bw.align(); var fb = bw.bytes(), c16 = crc16(fb, 0, bw.pos); bw.bits(c16, 16);
      parts.push(bw.bytes().slice());
      if (progress && frame % 20 === 0) progress(start / total);
    }
    return concat(parts);
  }

  // ------------------------------------------------------------ ID3v2.3
  function id3(meta) {
    var frames = [];
    function textFrame(id, txt) {
      var body = [1, 0xFF, 0xFE]; for (var i = 0; i < txt.length; i++) { var c = txt.charCodeAt(i); body.push(c & 255, c >> 8); }
      frames.push(frame(id, new Uint8Array(body)));
    }
    function frame(id, body) {
      var f = new Uint8Array(10 + body.length); for (var i = 0; i < 4; i++) f[i] = id.charCodeAt(i);
      var s = body.length; f[4] = (s >>> 24) & 255; f[5] = (s >>> 16) & 255; f[6] = (s >>> 8) & 255; f[7] = s & 255; f.set(body, 10); return f;
    }
    if (meta.title) textFrame('TIT2', meta.title);
    if (meta.artist) textFrame('TPE1', meta.artist);
    if (meta.cover) {
      var mime = utf8(meta.coverMime || 'image/jpeg'), b = new Uint8Array(1 + mime.length + 1 + 1 + 1 + meta.cover.length), o = 0;
      b[o++] = 0; b.set(mime, o); o += mime.length; b[o++] = 0; b[o++] = 3; b[o++] = 0; b.set(meta.cover, o);
      frames.push(frame('APIC', b));
    }
    if (!frames.length) return new Uint8Array(0);
    var body = concat(frames), size = body.length, h = new Uint8Array(10);
    h[0] = 73; h[1] = 68; h[2] = 51; h[3] = 3; h[4] = 0; h[5] = 0;
    h[6] = (size >>> 21) & 127; h[7] = (size >>> 14) & 127; h[8] = (size >>> 7) & 127; h[9] = size & 127;
    return concat([h, body]);
  }

  // ------------------------------------------------------------ ZIP (store)
  var CRC32 = (function () { var t = new Int32Array(256); for (var i = 0; i < 256; i++) { var c = i; for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1; t[i] = c; } return t; })();
  function crc32(u) { var c = -1; for (var i = 0; i < u.length; i++) c = CRC32[(c ^ u[i]) & 255] ^ (c >>> 8); return (c ^ -1) >>> 0; }
  function zip(files) { // [{name, data:Uint8Array}]
    var parts = [], central = [], off = 0;
    files.forEach(function (f) {
      var name = utf8(f.name), crc = crc32(f.data), lh = new Uint8Array(30 + name.length), v = new DataView(lh.buffer);
      v.setUint32(0, 0x04034b50, true); v.setUint16(4, 20, true); v.setUint16(6, 0x0800, true); v.setUint16(8, 0, true); v.setUint16(10, 0, true); v.setUint16(12, 0x21, true);
      v.setUint32(14, crc, true); v.setUint32(18, f.data.length, true); v.setUint32(22, f.data.length, true); v.setUint16(26, name.length, true); v.setUint16(28, 0, true); lh.set(name, 30);
      var ch = new Uint8Array(46 + name.length), w = new DataView(ch.buffer);
      w.setUint32(0, 0x02014b50, true); w.setUint16(4, 20, true); w.setUint16(6, 20, true); w.setUint16(8, 0x0800, true); w.setUint16(10, 0, true); w.setUint16(12, 0, true); w.setUint16(14, 0x21, true);
      w.setUint32(16, crc, true); w.setUint32(20, f.data.length, true); w.setUint32(24, f.data.length, true); w.setUint16(28, name.length, true);
      w.setUint32(42, off, true); ch.set(name, 46);
      parts.push(lh, f.data); central.push(ch); off += lh.length + f.data.length;
    });
    var cd = concat(central), end = new Uint8Array(22), e = new DataView(end.buffer);
    e.setUint32(0, 0x06054b50, true); e.setUint16(8, files.length, true); e.setUint16(10, files.length, true); e.setUint32(12, cd.length, true); e.setUint32(16, off, true);
    return concat(parts.concat([cd, end]));
  }

  // ------------------------------------------------------------ loudness (ITU-R BS.1770)
  function kfilter(x, sr) {
    function biq(b, a, inp) {
      var out = new Float32Array(inp.length), x1 = 0, x2 = 0, y1 = 0, y2 = 0;
      for (var i = 0; i < inp.length; i++) { var y = b[0] * inp[i] + b[1] * x1 + b[2] * x2 - a[1] * y1 - a[2] * y2; x2 = x1; x1 = inp[i]; y2 = y1; y1 = y; out[i] = y; }
      return out;
    }
    var G = 3.999843853973347, f0 = 1681.974450955533, Q = 0.7071752369554196;
    var K = Math.tan(Math.PI * f0 / sr), Vh = Math.pow(10, G / 20), Vb = Math.pow(Vh, 0.4996667741545416);
    var a0 = 1 + K / Q + K * K;
    var b1 = [(Vh + Vb * K / Q + K * K) / a0, 2 * (K * K - Vh) / a0, (Vh - Vb * K / Q + K * K) / a0], a1 = [1, 2 * (K * K - 1) / a0, (1 - K / Q + K * K) / a0];
    f0 = 38.13547087602444; Q = 0.5003270373238773; K = Math.tan(Math.PI * f0 / sr);
    var d = 1 + K / Q + K * K, b2 = [1, -2, 1], a2 = [1, 2 * (K * K - 1) / d, (1 - K / Q + K * K) / d];
    return biq(b2, a2, biq(b1, a1, x));
  }
  function lufs(chs, sr) {
    var f = chs.map(function (c) { return kfilter(c, sr); }), n = f[0].length, win = Math.round(0.4 * sr), hop = Math.round(0.1 * sr), z = [];
    if (n < win) win = hop = n;
    for (var s = 0; s + win <= n; s += hop) {
      var sum = 0; for (var c = 0; c < f.length; c++) { var d = f[c], m = 0; for (var i = s; i < s + win; i++) m += d[i] * d[i]; sum += m / win; } z.push(sum);
    }
    var L = function (v) { return -0.691 + 10 * Math.log10(v); };
    var g1 = z.filter(function (v) { return L(v) > -70; }); if (!g1.length) return -Infinity;
    var mean = g1.reduce(function (a, b) { return a + b; }, 0) / g1.length, rel = L(mean) - 10;
    var g2 = g1.filter(function (v) { return L(v) > rel; });
    return L(g2.reduce(function (a, b) { return a + b; }, 0) / g2.length);
  }
  // gain to target + lookahead peak limiter at ceiling (linear)
  function normalize(chs, sr, target, ceiling) {
    var cur = lufs(chs, sr); if (!isFinite(cur)) return { chs: chs, before: cur, after: cur };
    var db = target - cur, res = null;
    for (var it = 0; it < 4; it++) {
      res = limitGain(chs, sr, Math.pow(10, db / 20), ceiling);
      var after = lufs(res, sr), miss = target - after;
      if (Math.abs(miss) < 0.3 || db + miss > target - cur + 6) break;
      db += miss;
    }
    return { chs: res, before: cur, after: lufs(res, sr) };
  }
  function limitGain(chs, sr, g, ceiling) {
    var n = chs[0].length, look = Math.round(0.005 * sr), rel = Math.exp(-1 / (0.08 * sr));
    var need = new Float32Array(n);
    for (var i = 0; i < n; i++) { var p = 0; for (var c = 0; c < chs.length; c++) { var a = Math.abs(chs[c][i] * g); if (a > p) p = a; } need[i] = p > ceiling ? ceiling / p : 1; }
    // minimum over lookahead window, then smooth release
    var gr = new Float32Array(n), env = 1, dq = [];
    for (i = 0; i < n + look; i++) {
      if (i < n) { while (dq.length && need[dq[dq.length - 1]] >= need[i]) dq.pop(); dq.push(i); }
      var j = i - look; if (j < 0) continue;
      while (dq[0] < j - look) dq.shift();
      var m = need[dq[0]];
      env = m < env ? m : env * rel + (1 - rel) * m; if (env > m) env = Math.min(env, m * 1.0);
      gr[j] = Math.min(env, m);
    }
    return chs.map(function (c) { var o = new Float32Array(n); for (var k = 0; k < n; k++) { var v = c[k] * g * gr[k]; o[k] = v > ceiling ? ceiling : v < -ceiling ? -ceiling : v; } return o; });
  }
  // ------------------------------------------------------------ silence trim
  function trim(chs, sr) {
    var n = chs[0].length, th = 0.0005, a = 0, b = n - 1, i, c;
    outer1: for (i = 0; i < n; i++) for (c = 0; c < chs.length; c++) if (Math.abs(chs[c][i]) > th) { a = i; break outer1; }
    outer2: for (i = n - 1; i >= 0; i--) for (c = 0; c < chs.length; c++) if (Math.abs(chs[c][i]) > th) { b = i; break outer2; }
    if (b <= a) return chs;
    var pad = Math.round(0.01 * sr); a = Math.max(0, a - pad); b = Math.min(n - 1, b + pad);
    var f = Math.round(0.005 * sr);
    return chs.map(function (d) { var o = d.slice(a, b + 1); for (var k = 0; k < f && k < o.length; k++) { o[k] *= k / f; o[o.length - 1 - k] *= k / f; } return o; });
  }
  function peakGain(chs, ceil) { var p = 0; chs.forEach(function (d) { for (var i = 0; i < d.length; i++) { var a = Math.abs(d[i]); if (a > p) p = a; } }); return p > ceil ? ceil / p : 1; }

  return { wav: wav, flac: flac, id3: id3, zip: zip, crc32: crc32, lufs: lufs, normalize: normalize, trim: trim, peakGain: peakGain, concat: concat };
})();
if (typeof module !== 'undefined') module.exports = NAUDIO;
